import { useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import pusher from '../../utils/pusher';
import { noReloadUpdateTrendings } from '../../../redux/actions/trending';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import './style.scss';
import PageReload from '../../common/PageReload';

// const PageReloadContainer = styled.div`
//     padding: 10px;
//     margin-bottom: 12px;
//     background: #ffc784;
//     color: #666;
//     z-index: 999999;
//     width: 100%;
//     text-align: center;
//     display: block;
// `;


const LoggedInContainer = ({ topSection, menu, content, ...rest }) => {
    const isMobile = useMediaQuery('( max-width: 899px )');
    const dispatch = useDispatch();

    // pusher sequence - start
    const [suChannelName, setSuChannelName] = useState('');
    const [suChannel, setSuChannel] = useState('');

    const updateTrendingsList = (data) => {
        dispatch(noReloadUpdateTrendings({
            ...data
        }));
    };

    const handleTrendingPuPriceUpdateEvent = data => {
        updateTrendingsList(data.pu);
    };

    useEffect(() => {
        let isMounted = true;
        // retrieve logged in user's info
        const userInformation = JSON.parse(localStorage.getItem('user'));

        // check if logged in user is SU
        if (userInformation.role == 0) {
            // set channel name
            setSuChannelName(`private-chat-${localStorage.getItem('loggedin_user')}`);
        }

        return () => {
            let isMounted = false;

            if (suChannel && suChannelName) {
                pusher.unsubscribe(suChannelName);
            }
        };
    }, []);

    useEffect(() => {
        if (suChannelName) {
            setSuChannel(pusher.subscribe(suChannelName));
        }
    }, [suChannelName]);

    useEffect(() => {
        if (suChannel) {
            suChannel.bind('App\\Events\\TrendingPuPriceUpdateEvent', d => {
                handleTrendingPuPriceUpdateEvent(d);
            });
        }
    }, [suChannel]);
    // pusher sequence - end

    return <Container
        maxWidth="xl"
        disableGutters={isMobile}
    >
        <Grid xs={12}>
            <PageReload />
            {/* <PageReloadContainer className="page-reload">
                We are currently performing a maintenance update  on our server.    Please try again in about 20 minutes.  Thank you.
            </PageReloadContainer> */}
            {topSection}
        </Grid>
        <Grid
            container
            spacing={isMobile ? 0 : 1}
            columns={16}
        >
            <Grid md={3} className="sidebar-menu-container">
                {menu}
            </Grid>

            <Grid xs={16} md={13} className='content-container'>
                {content}
            </Grid>
        </Grid>
    </Container>;
};

export default LoggedInContainer;